export const PROJECT_CARRIER_MAP_STATUS = {
	PROCURED: 'PROCURED',
	IN_PROGRESS: 'IN_PROGRESS',
};
